import { SearchCriteria } from "../../model/SearchCriteria";
import { SearchResultItem } from "../../model/SearchResultItem";
import ServiceEndpoints from "../ServiceEndpoints";

export interface SearchError {
  message: string;
  errors?: string[];
}

export async function searchCriteriaForm(searchCriteria: SearchCriteria, page: any, pageSize: any, isExactOnly: any, isAkaEnabled: any, token: any): Promise<SearchResultItem | SearchError> {
    const searchOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
      body: JSON.stringify(searchCriteria),
    };

    try {
      const response = await fetch(ServiceEndpoints.Search + "?page=" + page + "&pageSize=" + pageSize +  "&isExactOnly=" + isExactOnly + "&isAkaEnabled=" + isAkaEnabled, searchOptions);

      if (response.status === 200) {
        const data = await response.json();
        data.results.forEach((result: any) => {
          result.searchScore = result['@search.score'];
        });
        return data as SearchResultItem;
      } else {
        const errorData = await response.json();

        // Handle 400 error with field errors
        if (response.status === 400 && errorData && errorData.errors && Array.isArray(errorData.errors)) {
          return {
            message: "Validation error",
            errors: errorData.errors
          };
        }

        throw new Error("Request failed with status: " + response.status);
      }
    } catch (error) {
      console.error("API error " + error);
      return  {
        results: [{
          PersonId: 0,
          FirstName: "",
          LastName: "",
          LegalName: "",
          CountryInc: "",
          LeiRegistration: "",
          CityOfBirth: "",
          CountryOfBirth: "",
          PersonType: "",
          AlsoKnownAs: "",
          DateOfBirth: "",
          SocialSecurityNumber: "",
          ID: "",
          IsExactMatch: false,
          IsAkaEnabled: true,
          CAInternalAssessmentNo: "",
          personOfInterestId: 0,
          searchScore: 0,
          AssessmentId: 0
        }],
        totalItems: 0,
        totalPages: 0
      }
    }
  }
